import React from 'react';
import axios from '../axios';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';

const SectionCircle = ({
  event,
  setEvent,
  usersCircles,
  setUsersCircles,
  circleError,
}) => {
  const [newCircle, setNewCircle] = React.useState({});
  const [selected, setSelected] = React.useState(event.circle_id);
  const [newCircleError, setNewCircleError] = React.useState(null);
  const [isCreatingCircle, setIsCreatingCircle] = React.useState(false);
  const modalRef = React.useRef(null);

  const newCircleName = (newCircle.name || '').trim();

  const closeModal = React.useCallback(() => {
    // 10個目の作成直後はモーダル自体が条件レンダリングから外れて
    // アンマウント済みになるため、ref が null になりうる（TGW-2481）
    modalRef.current?.closeModal();
  });

  const createNewCircle = React.useCallback(() => {
    // モーダルは閉じてもアンマウントされないため、二重送信ガードが無いと
    // 連打・再オープンで同じサークルが重複作成される（TGW-2481）
    if (isCreatingCircle || !newCircleName) {
      return;
    }
    const circleName = JSON.stringify({
      circle_name: newCircleName,
    });
    setIsCreatingCircle(true);
    setNewCircleError(null);
    axios
      .post(`/api/event_edit/${event.id}/create_new_circle`, circleName)
      .then((response) => {
        setUsersCircles((prev) => [...prev, response.data]);
        setSelected((prevSelected) =>
          prevSelected === response.data.id ? prevSelected : response.data.id
        );
        // 閉じても state は残るので、次に開いたときのために入力を破棄する
        setNewCircle({});
        setNewCircleError(null);
        closeModal();
      })
      .catch((error) => {
        setNewCircleError(
          error?.response?.data?.error ||
            'サークルの作成に失敗しました。時間をおいて再度お試しください。'
        );
      })
      .finally(() => {
        setIsCreatingCircle(false);
      });
  }, [newCircleName, isCreatingCircle, event.id]);

  const updateEventsCircle = React.useCallback(
    (e) => {
      const circleId = e;
      const newEvent = {
        ...event,
        circle_id: circleId,
      };
      setEvent(newEvent);
      axios.post(
        `/api/event_edit/${event.id}/update_events_circle/${e}`,
        newEvent
      );
      setSelected((prevSelected) =>
        prevSelected === circleId ? prevSelected : circleId
      );
    },
    [event]
  );

  return (
    <section id="event_details">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          主催サークル
        </p>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6">
          {circleError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{circleError}</p>
          )}
          <div className="card-body p-0">
            <ul
              className="row flex-nowrap overflow-auto px-2 pt-3"
              style={{ listStyle: 'none' }}
            >
              {usersCircles && usersCircles.length < 10 && (
                <ModalContentBaseXl
                  ref={modalRef}
                  previewContent={
                    <li className="w-100">
                      <label className="circle-container">
                        <img
                          src="/images/ja2/img_noimage.gif"
                          className="circle-image"
                          alt="no-image"
                        ></img>
                        <div className="circle-overlay"></div>
                        <div className="circle-content">
                          <div className="circle-name-container">
                            <span
                              className="circle-name line-2 align-items-end"
                              style={{ position: 'absolute', bottom: '6%' }}
                            >
                              新規サークルで作成
                              <span>
                                <img
                                  src="/assets2019/add_circle_icon_ver_red.svg"
                                  alt=""
                                  className="pr-1"
                                ></img>
                              </span>
                            </span>
                          </div>
                        </div>
                      </label>
                    </li>
                  }
                  modalContent={
                    <div className="container col-md-8 col-lg-6 mt-5">
                      <p className="pt-2 form-label text-fz-20px text-fw-bold text-black-50 text-center">
                        新規サークル作成
                      </p>
                      <div className="mb-4">
                        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">
                          サークル名
                        </p>
                        <textarea
                          id="body"
                          className="form-control form-control-lg"
                          value={newCircle.name || ''}
                          disabled={isCreatingCircle}
                          onChange={(e) => {
                            setNewCircle({
                              ...newCircle,
                              name: e.target.value,
                            });
                            setNewCircleError(null);
                          }}
                        />
                        {newCircleError && (
                          <p className="text-danger text-fz-small mt-1 mb-0">
                            {newCircleError}
                          </p>
                        )}
                      </div>
                      <div
                        className="w-100"
                        style={{ paddingRight: '10px', paddingLeft: '10px' }}
                      >
                        <button
                          type="button"
                          className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
                          value="semi_official"
                          disabled={!newCircleName || isCreatingCircle}
                          onClick={createNewCircle}
                        >
                          {isCreatingCircle ? '作成中...' : '新規サークル作成'}
                        </button>
                      </div>
                      <p className="text-center form-label text-fz-10px text-black-50">
                        サークル設定の変更はマイページから行えます。
                      </p>
                    </div>
                  }
                />
              )}
              {usersCircles.map((circle) => (
                <li key={circle.id} className="">
                  <label
                    key={circle.id}
                    className="circle-container"
                    style={{
                      border:
                        selected === circle.id ? '5px solid #FF6467' : 'none',
                    }}
                  >
                    <img
                      src={`${circle.main_image_thumb}`}
                      className="circle-image"
                      alt="サークル画像"
                    ></img>
                    <div className="circle-overlay"></div>
                    <div className="circle-content">
                      <div className="circle-name-container">
                        <span
                          className="circle-name line-2"
                          style={{ position: 'absolute', bottom: '6%' }}
                        >
                          {circle.name}
                        </span>
                        <input
                          type="checkbox"
                          style={{ display: 'none' }}
                          value={circle.id}
                          checked={selected == circle.id}
                          onChange={(e) =>
                            updateEventsCircle(Number(e.target.value))
                          }
                        />
                      </div>
                    </div>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionCircle;
